import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import PrestaCard from "../components/PrestaCard";
import Arrow from "../../img/angle-right.svg";
// import AnchorLink from "react-anchor-link-smooth-scroll";

const Prestations = () => {
  const prestations = [
    {
      id: 0,
      title: "Séances shooting",
      duration: "1h",
      description: "Séances personnalisées pour particuliers, artistes et professionnels. Capturer votre essence avec créativité et authenticité.",
      price: "À partir de 120€",
      includedServices: [
        "10 photos haute résolution retouchées", 
      ],
      characteristics: [
        "Séance en studio ou en extérieur",
        "Retouche professionelle",
        "Livraison sous 48h",
        "Format numérique HD",
        "Photo argentique sur demande",
      ],
      bgImage: 0,
    },
    {
      id: 1,
      title: "Événements et reportages",
      duration: "Demi-journée",
      description: "Couverture complète de vos événements: festivals, concerts, mariages, entreprise. Immortalisez vos moments précieux avec un oeil artistique.",
      price: "À partir de 200€",
      includedServices: [
        "Couverture complète de l'événement",
        "50-100 photos haute résolution",
        "Photos en haute définition",
      ],
      characteristics: [
        "Matériel professionnel",
        "Prise de vue aérienne sur demande",
        "Livraison sous 48h",
      ],
      bgImage: 1,
    },
    {
      id: 2,
      title: "Prise de vue aérienne",
      duration: "Session",
      description: "Perspectives uniques par drone, pour les événements, les paysages et l'immobilier. Pilote certifié DGAC avec matériel professionnel 4K.",
      price: "À partir de 200€",
      includedServices: [
        "Photos aériennes 4K",
        "Vidéos professionnelles",
        "Respect de la réglementation",
      ],
      characteristics: [
        "Pilote certifié DGAC",
        "Matériel professionnel 4K",
        "Autorisation de vol incluse",
      ],
      bgImage: 2,
    },
  ];

  return (
    <main className="prestations-page">
      <div className="title-container">
        <h1 id="prestations" className="title">Mes Prestations</h1>
        <div className="title-separator"></div>
      </div>

      <motion.p id="prestations-subtitle">
        Découvrez mes services photographiques adaptés à tous vos besoins
      </motion.p>

      <div id="prestations-list">
        {prestations.map((prestation, index) => (
          <React.Fragment key={index}>
            <PrestaCard {...prestation} />
            {index < prestations.length - 1 && (<div className="title-separator"></div>)}

            {/* pas la derniere carte de l'index
            {index < prestations.length - 1 && (
              <AnchorLink href={`#presta-card-${prestation.id + 1}`} aria-label="go to next card">
                <img src={Arrow} alt="Go to next card" style={{ width: '50px', transform: 'rotate(205deg)', filter: 'brightness(0%)'}}/>
              </AnchorLink>
            )} */}
          </React.Fragment>
        ))}
      </div>

      <motion.div>
        <div id="prestations-bottom">
          <h3>Projet sur mesure ?</h3>
          <p>Chaque projet est unique. Contactez-moi pour un devis personnalisé adapté à vos besoins spécifiques.</p>
        </div>

        <div id="prestations-contact">
          <NavLink to="/contact" id="prestations-contact-link">
            <button className="classic-button">Demander un devis <img src={Arrow} alt="Arrow"/></button>
          </NavLink>
        </div>
      </motion.div>
    </main>
  );
};

export default Prestations;